/* eslint-disable max-classes-per-file */
import { Cellstyle, HotCell } from "@components/hot-doc/hotdoc/cell";
import { ForsorjningskallaAggregat } from "~app/common/models/forsorjningskalla";
import { LeverantorsorderradAggregat } from "../models/jlp-leverantorsoder-model";

/* eslint-disable no-bitwise */

export class LeverantorsorderradCell extends HotCell {

    constructor(private readonly markupBuilder: () => string) {
        super(Cellstyle.Readonly | Cellstyle.NoRightBorder | Cellstyle.StrongTop, { rowSpan: 3 });
    }

    static create(source: LeverantorsorderradAggregat): LeverantorsorderradCell {
        const buildMarkup = (): string => {
            const leverantorLink =
                `<a href="/core/leverantorsorder/${source.id}"><span data-bs-toggle="tooltip" title="${source.leverantor}">${source.leverantor.substring(0, 20)}</span></a>`;
            return `<div>${leverantorLink}</div><div>${source.leverantorsNummer}</div><div>${source.handelssortimentsGrupp} ${source.mattslag}</div>`;
        };

        return new LeverantorsorderradCell(buildMarkup);
    }

    validate(value: any): boolean {
        return false;
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return this.markupBuilder();
    }
}

export class LeverantorsorderForsorjningskallaCell extends HotCell {
    private readonly markup: string;

    constructor(private readonly markupBuilder: () => string) {
        super(Cellstyle.Readonly | Cellstyle.White | Cellstyle.NoRightBorder, { rowSpan: 2 });
    }

    static create(source: ForsorjningskallaAggregat): LeverantorsorderForsorjningskallaCell {
        const buildMarkup = (): string => {
            const link = `<a href="/core/kundorder/${source.kundorderId}"><span data-bs-toggle="tooltip" title="${source.namn}">${source.namn.substring(0, 20)}</span></a>`;
            const mottagningsplats = `<span style="font-size: 11px">${source.mottagningsplats}</span>`;
            const sortiment = `<span style="font-size: 11px">${source.sortiment}</span>`;
            return `<div>${link}</div><div>${mottagningsplats}</div><div>${sortiment}</div>`;
        };

        return new LeverantorsorderForsorjningskallaCell(buildMarkup);
    }

    validate(value: any): boolean {
        return false;
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return this.markupBuilder();
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.style.verticalAlign = "middle";
        td.style.textAlign = "left";
    }
}
